// Feature 148: spostamento di un collo o di un bancale fra righe di spedizione.

export interface SpostaColloRequest {
  idDocDest: number;
  idRigDest: number;
  codiceCollo: string;
  // Bancale della riga di destinazione, esistente o appena creato con app-box-input
  codBancaleDest: string;
  // true se codBancaleDest è stato appena creato: eSOLVER riceve NuovoUDC = 1
  nuovoBancale: boolean;
  inviaEsolver: boolean;
  operatore?: string;
}

export interface SpostaBancaleRequest {
  idDocDest: number;
  idRigDest: number;
  codBancale: string;
  inviaEsolver: boolean;
  operatore?: string;
  // Feature 156: colli scelti; vuoto o assente = tutto il bancale (comportamento 148)
  codiciColli?: string[];
  // Con una selezione parziale: bancale della destinazione che riceve i colli scelti
  codBancaleDest?: string;
  nuovoBancale?: boolean;
}

export interface SpostaColloEsito {
  colliSpostati: number;
  qtaSpostata: number;
  giaSpostato: boolean;
  spedizioneLanciata: boolean;
  esolverInviato: boolean;
  codBancaleDest?: string;
}

// Errore del packing quando il bancale selezionato è stato spostato in un'altra spedizione (FR-026).
// Feature 156: eSOLVER ha rifiutato un collo a metà; quelli prima sono già stati spostati.
export const SPOSTA_ESOLVER_PARZIALE = 'SPOSTA_ESOLVER_PARZIALE';

export const PACKING_BANCALE_ALTRA_SPEDIZIONE = 'PACKING_BANCALE_ALTRA_SPEDIZIONE';

// Corpo di un errore di spostamento o di packing: { errorType, error }.
export function erroreSpostamento(err: unknown): { errorType?: string; error?: string } {
  const corpo = (err as { error?: { errorType?: unknown; error?: unknown } } | undefined)?.error;
  return {
    errorType: typeof corpo?.errorType === 'string' ? corpo.errorType : undefined,
    error: typeof corpo?.error === 'string' && corpo.error ? corpo.error : undefined
  };
}
